// extracted by mini-css-extract-plugin
export default {"root":"orjFxU","dot":"O5JBGO","isSelected":"XdOIa8"};